<p-progressBar
  mode="indeterminate"
  styleClass="page-loading-bar"
  *ngIf="loading"
></p-progressBar>